import { useState, useEffect } from "react";

import { Box, Button, Divider, Stack, Grid } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import { API, PAGE, AGENT } from "../../config";
import { getAPI, fni18n, fnCallPopUp, } from "../../services/commonService";
import AuthenticationService from "../../pages/auth/AuthenticationService";

import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import UButton from "../../components/mui/UButton";
import USelectBox from "../../components/mui/USelectBox";
import UTable from "../../components/mui/UTable";
import UPopupForm from "../../components/mui/UPopupForm";
import VaultPopUpPage from "./VaultPopUpPage";

export default function VaultPage(){
    const userLoginId = AuthenticationService.getLoggedInUserID();
    const [branchs, setBranch] = useState([]);
    const [retailers, setRetailers] = useState([]);
    const [transType, setTransType] = useState([]);
    const [search, setSearch] = useState({
        // pageNum: "1"
        // ,storeCd: "N/A"
        // ,brandCd: "N/A"
    });
    const [rows1, setRows1] = useState([]);
    const [rows2, setRows2] = useState([]);
    const [machineList, setMachineList] = useState([]);
    const [brands, setBrands] = useState([]);
    const [ formOpen, setFormOpen ] = useState(false); // detail dialog
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const columns = [
        {
            field: 'id',
            headerName: 'No',
            align: "center",
            headerAlign: "center",
            hide: true,
        },
        {
            field: 'storeCd',
            headerName: '지점',
            align: "center",
            headerAlign: "center",
            hide: true,
        },
        {
            field: 'machId',
            headerName: '기기번호',
            editable: false,
            align: "center",
            headerAlign: "center"
        },
        {
            field: 'finalDs',
            headerName: '마감일자',
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: 'fnsetTyNm',
            headerName: '거래유형',
            editable: false,
            align: "center",
            headerAlign: "center",
            hide: true,
        },
        //Bill
        {
            field: 'billCnt',
            headerName: '지폐',
            headerAlign: 'center',
            align: 'center',
            colSpan: [
                {
                    parentField: 'billCnt',
                    field: 'usdBill100Cnt',
                    headerName: '$100',
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        if (params.value == null) {
                            return '0';
                        }
                        return Number(params.value).toLocaleString('en-US');
                    }
                },    
                {
                    parentField: 'billCnt',
                    field: 'usdBill50Cnt',
                    headerName: '$50',
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        if (params.value == null) {
                            return '0';
                        }
                        return Number(params.value).toLocaleString('en-US');
                    }
                },    
                {
                    parentField: 'billCnt',
                    field: 'usdBill20Cnt',
                    headerName: '$20',
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        if (params.value == null) {
                            return '0';
                        }
                        return Number(params.value).toLocaleString('en-US');
                    }
                },    
                {
                    parentField: 'billCnt',
                    field: 'usdBill10Cnt',
                    headerName: '$10',
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        if (params.value == null) {
                            return '0';
                        }
                        return Number(params.value).toLocaleString('en-US');
                    }
                },    
                {
                    parentField: 'billCnt',
                    field: 'usdBill5Cnt',
                    headerName: '$5',
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        if (params.value == null) {
                            return '0';
                        }
                        return Number(params.value).toLocaleString('en-US');
                    }
                },    
                {
                    parentField: 'billCnt',
                    field: 'usdBill1Cnt',
                    headerName: '$1',
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        if (params.value == null) {
                            return '0';
                        }
                        return Number(params.value).toLocaleString('en-US');
                    }
                },
                {   
                    parentField: 'billCnt',
                    field: 'usdBillTotCnt',
                    headerName: '합계',
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
            ],
        },
        //Coin_out
        {
            field: 'CoinOutCnt',
            headerName: '동전출금 / 동전입금',
            headerAlign: 'center',
            align: 'center',
            colSpan: [
                {
                    parentField: 'CoinOutCnt',
                    field: 'usdInOutCoin100Cnt',
                    headerName: '100₵',
                    // width: 40,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        var inOutCoin = params.value.split(",");
                        if(Number(inOutCoin[0]) != 0 && !isNaN(inOutCoin[0])) {
                            inOutCoin[0] = Number(inOutCoin[0]).toLocaleString('en-US');
                        } else inOutCoin[0] = 0;
                        if(Number(inOutCoin[1]) != 0 && !isNaN(inOutCoin[1]) ) {
                            inOutCoin[1] = Number(inOutCoin[1]).toLocaleString('en-US')
                        } else inOutCoin[1] = 0;
                        return (
                            <>
                                {inOutCoin[0]}
                                <br />
                                {inOutCoin[1]}
                            </>
                        );
                    }
                },
                {
                    parentField: 'CoinOutCnt',
                    field: 'usdInOutCoin50Cnt',
                    headerName: '50₵',
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        var inOutCoin = params.value.split(",");
                        if(Number(inOutCoin[0]) != 0 && !isNaN(inOutCoin[0])) {
                            inOutCoin[0] = Number(inOutCoin[0]).toLocaleString('en-US');
                        } else inOutCoin[0] = 0;
                        if(Number(inOutCoin[1]) != 0 && !isNaN(inOutCoin[1]) ) {
                            inOutCoin[1] = Number(inOutCoin[1]).toLocaleString('en-US')
                        } else inOutCoin[1] = 0;
                        return (
                            <>
                                {inOutCoin[0]}
                                <br />
                                {inOutCoin[1]}
                            </>
                        );
                    }
                },    
                {
                    parentField: 'CoinOutCnt',
                    field: 'usdInOutCoin25Cnt',
                    headerName: '25₵',
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        var inOutCoin = params.value.split(",");
                        if(Number(inOutCoin[0]) != 0 && !isNaN(inOutCoin[0])) {
                            inOutCoin[0] = Number(inOutCoin[0]).toLocaleString('en-US');
                        } else inOutCoin[0] = 0;
                        if(Number(inOutCoin[1]) != 0 && !isNaN(inOutCoin[1]) ) {
                            inOutCoin[1] = Number(inOutCoin[1]).toLocaleString('en-US')
                        } else inOutCoin[1] = 0;
                        return (
                            <>
                                {inOutCoin[0]}
                                <br />
                                {inOutCoin[1]}
                            </>
                        );
                    }
                },    
                {
                    parentField: 'CoinOutCnt',
                    field: 'usdInOutCoin10Cnt',
                    headerName: '10₵',
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        var inOutCoin = params.value.split(",");
                        if(Number(inOutCoin[0]) != 0 && !isNaN(inOutCoin[0])) {
                            inOutCoin[0] = Number(inOutCoin[0]).toLocaleString('en-US');
                        } else inOutCoin[0] = 0;
                        if(Number(inOutCoin[1]) != 0 && !isNaN(inOutCoin[1]) ) {
                            inOutCoin[1] = Number(inOutCoin[1]).toLocaleString('en-US')
                        } else inOutCoin[1] = 0;
                        return (
                            <>
                                {inOutCoin[0]}
                                <br />
                                {inOutCoin[1]}
                            </>
                        );
                    }
                },    
                {
                    parentField: 'CoinOutCnt',
                    field: 'usdInOutCoin5Cnt',
                    headerName: '5₵',
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        var inOutCoin = params.value.split(",");
                        if(Number(inOutCoin[0]) != 0 && !isNaN(inOutCoin[0])) {
                            inOutCoin[0] = Number(inOutCoin[0]).toLocaleString('en-US');
                        } else inOutCoin[0] = 0;
                        if(Number(inOutCoin[1]) != 0 && !isNaN(inOutCoin[1]) ) {
                            inOutCoin[1] = Number(inOutCoin[1]).toLocaleString('en-US')
                        } else inOutCoin[1] = 0;
                        return (
                            <>
                                {inOutCoin[0]}
                                <br />
                                {inOutCoin[1]}
                            </>
                        );
                    }
                },    
                {
                    parentField: 'CoinOutCnt',
                    field: 'usdInOutCoin1Cnt',
                    headerName: '1₵',
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        var inOutCoin = params.value.split(",");
                        if(Number(inOutCoin[0]) != 0 && !isNaN(inOutCoin[0])) {
                            inOutCoin[0] = Number(inOutCoin[0]).toLocaleString('en-US');
                        } else inOutCoin[0] = 0;
                        if(Number(inOutCoin[1]) != 0 && !isNaN(inOutCoin[1]) ) {
                            inOutCoin[1] = Number(inOutCoin[1]).toLocaleString('en-US')
                        } else inOutCoin[1] = 0;
                        return (
                            <>
                                {inOutCoin[0]}
                                <br />
                                {inOutCoin[1]}
                            </>
                        );
                    }
                },    
                {
                    parentField: 'CoinOutCnt',
                    field: 'InoutCoinTotCnt',
                    headerName: '합계',
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        var totCnt = params.value.split(",");
                        
                        if(Number(totCnt[0]) != 0 ) {
                            totCnt[0] = "$"+Number(totCnt[0]).toLocaleString("en-US");
                        } else totCnt[0] = 0;
                        if(Number(totCnt[1]) != 0 ) {
                            totCnt[1] ="$"+Number(totCnt[1]).toLocaleString("en-US")
                        } else totCnt[1] = 0;
                        return (
                            <>
                                {totCnt[0]}
                                <br />
                                {totCnt[1]}
                            </>
                        );
                    }
                },
            ]
        },
        
       //리젝함 금액
        {
            field: 'rejtAmnt', 
            headerName: '리젝함',
            editable: false,
            align: "right",
            headerAlign: "center",
        },
       //봉투입금함 금액
        {
            field: 'envelopeAmnt', 
            headerName: '봉투입금함',
            editable: false,
            align: "right",
            headerAlign: "center",
        },
       //보회함 금액
        {
            field: 'transitcstAmnt', 
            headerName: '보회함',
            editable: false,
            align: "right",
            headerAlign: "center",
        },
       //출금 총합
        {
            field: 'totalAmount',
            headerName: '총합계',
            editable: false,
            align: "right",
            headerAlign: "center",
        },
        //리젝함 불명권 매수
        {
            field: 'rejtUnkcnt', 
            headerName: '리젝함 불명권 매수',
            editable: false,
            align: "center",
            headerAlign: "center",
            valueFormatter: (params)=>{
                if (params.value > 0) {
                return (
                    <div
                    style={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "red",
                    }}
                    >
                    {params.value}
                    </div>
                );
                }
                return params.value;
            }
        },
        {
            field: 'hist',
            headerName: '상세',
            align: "right",
            sortable: false,
            headerAlign: "center",
            align: "center",
            renderCell: (params) =>
            (
                <UButton variant="outlined" onButtonClick={(e)=>handleRowSelect(params)}>보기</UButton>
            ),
        },
    ];

    //화면 로드 시
    useEffect(() => {
        const getLoadData = async () => {
            try {
                await Promise.all([
                    loadComboBoxBranchGroup(),
                    loadComboBoxBranch(),
                    loadComboBoxTransType()
                ]);
            } catch (e) {
                console.error('초기 로딩 실패:', e.message);
            }
        };
        getLoadData();
    }, []);

    useEffect(() => {
        if (!isFirstLoad) return;
        if (search.storeCd) {
            loadDataGrid1();
            setIsFirstLoad(false);
        }
    }, [search]);
    
    const clearSearchVal = ()=>{
        setSearch({
            ...search,
            ['storeCd']: 'N/A',
        });
        setMachineList([]);
        setBrands([]);
    }

    // 콤보박스 데이터
    const loadComboBoxBranchGroup = async () => {
        try {
            const res = await getAPI(API.COMMON.BRANCH_GROUP, {userId: userLoginId,branchGroupTy: "BIZ_TY",useYn:"Y"});
            const _inputData = res.data.result.map((m) => ({
                cd: m.id,
                name: m.branchGroupNm,
            }));
            setRetailers(_inputData);
            // await loadComboBoxBranch(_inputData[0].cd);
        } catch (e) {
            console.error(e.message);
        }
    };
    const loadComboBoxBranch = async(param) => {
        try{
            const res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId, bizTy:param, });
            const _inputData = res.data.result.map((m) => ({
                    cd: m.storeCd,
                    name: m.storeNm,
                })
            );
            setBranch(_inputData );
            if (_inputData.length > 0) {
                await loadComboBoxMachineNo(_inputData[0].cd);
                await loadComboBoxBrand(_inputData[0].cd);
            } else {
                clearSearchVal()
            }
        }catch(e){
            console.error(e.message);
        }
    };
    const loadComboBoxMachineNo = async (branch) => {
        try{
            const res = await getAPI(API.COMMON.MACHINE+branch);
            const _inputData = res.data.result.map((m) => ({
                    cd: m.machId,
                    name: m.machId,
                })
            );
            setMachineList(_inputData );
        }catch(e){
            console.error(e.message);
        }
    };
    const loadComboBoxTransType = async() => {
        try{
            const res = await getAPI(API.COMMON.TRANS_TYPE);
            const _inputData = res.data.result.map((m) => ({
                    cd: m.cd,
                    name: m.cdNm,
                })
            );
            setTransType(_inputData );
        }catch(e){
            console.error(e.message);
        }
    };
    const loadComboBoxBrand = async (branch) => {
        try{
            const res = await getAPI(API.COMMON.BRAND, { userId: userLoginId, branch: branch});
            const _inputData = res.data.result.map((m) => ({
                    cd: m.brandCd,
                    name: m.brandNm,
                })
            );
            if (_inputData.length > 0) {
                setSearch({
                    ...search,
                    ['brandCd'] : _inputData[0].cd,
                    ['storeCd'] : branch,
                })
            } else {
                setSearch({
                    ...search,
                    ['brandCd'] : "N/A",
                    ['storeCd'] : branch,
                })
            }
            setBrands(_inputData );
        }catch(e){
            console.error(e.message);
        }
    };
    const onSearchChange = (e) => {
        const {name, value} = e.target;
        setSearch({
            ...search,
            [name] : value==='ALL'?'':value,
        })
        if (name === "bizTy") {
            loadComboBoxBranch(value);
        }
        //지점선택 후 기번 가져오기
        if (name === "storeCd") {
            loadComboBoxMachineNo(value);
            loadComboBoxBrand(value);
        }
    };
    //데이터그리드
    const loadDataGrid1 = async() => {
        await getAPI(API.CASH.VAULT_CNT,search).then((res) => {
            const _inputData = res.data.result.map((rowData)=>({
                id: rowData.id,
                storeCd: rowData.storeCd,
                machId: rowData.machId,
                fnsetTy: rowData.fnsetTy,
                fnsetTyNm: rowData.fnsetTyNm,
                saleDt: rowData.saleDt,
                finalDs: rowData.finalDs,
                usdBillTotCnt: isNaN(rowData.usdBillTotCnt)?"0":"$"+Number(rowData.usdBillTotCnt).toLocaleString("en-US"),
                usdBill100Cnt: rowData.usdBill100Cnt,
                usdBill50Cnt: rowData.usdBill50Cnt,
                usdBill20Cnt: rowData.usdBill20Cnt,
                usdBill10Cnt: rowData.usdBill10Cnt,
                usdBill5Cnt: rowData.usdBill5Cnt,
                usdBill2Cnt: rowData.usdBill2Cnt,
                usdBill1Cnt: rowData.usdBill1Cnt,
                outCoinTotCnt: isNaN(rowData.outCoinTotCnt)?"0":"$"+Number(rowData.outCoinTotCnt).toLocaleString("en-US"),
                usdOutCoin100Cnt: rowData.usdOutCoin100Cnt,
                usdOutCoin50Cnt: rowData.usdOutCoin50Cnt,
                usdOutCoin25Cnt: rowData.usdOutCoin25Cnt,
                usdOutCoin10Cnt: rowData.usdOutCoin10Cnt,
                usdOutCoin5Cnt: rowData.usdOutCoin5Cnt,
                usdOutCoin1Cnt: rowData.usdOutCoin1Cnt,
                inCoinTotCnt: isNaN(rowData.inCoinTotCnt)?"0":"$"+Number(rowData.inCoinTotCnt).toLocaleString("en-US"),
                usdInCoin100Cnt: rowData.usdInCoin100Cnt,
                usdInCoin50Cnt: rowData.usdInCoin50Cnt,
                usdInCoin25Cnt: rowData.usdInCoin25Cnt,
                usdInCoin10Cnt: rowData.usdInCoin10Cnt,
                usdInCoin5Cnt: rowData.usdInCoin5Cnt,
                usdInCoin1Cnt: rowData.usdInCoin1Cnt,
                usdInOutCoin100Cnt: rowData.usdOutCoin100Cnt +"," + rowData.usdInCoin100Cnt,
                usdInOutCoin50Cnt: rowData.usdOutCoin50Cnt +"," + rowData.usdInCoin50Cnt,
                usdInOutCoin25Cnt: rowData.usdOutCoin25Cnt +"," + rowData.usdInCoin25Cnt,
                usdInOutCoin10Cnt: rowData.usdOutCoin10Cnt +"," + rowData.usdInCoin10Cnt,
                usdInOutCoin5Cnt : rowData.usdOutCoin5Cnt +"," + rowData.usdInCoin5Cnt,
                usdInOutCoin1Cnt: rowData.usdOutCoin1Cnt + "," + rowData.usdInCoin1Cnt,
                InoutCoinTotCnt: rowData.outCoinTotCnt + "," + rowData.inCoinTotCnt,
                rejtAmnt: isNaN(rowData.rejtAmnt)?"0":"$"+Number(rowData.rejtAmnt).toLocaleString("en-US"),
                envelopeAmnt: isNaN(rowData.envelopeAmnt)?"0":"$"+Number(rowData.envelopeAmnt).toLocaleString("en-US"),
                transitcstAmnt: isNaN(rowData.transitcstAmnt)?"0":"$"+Number(rowData.transitcstAmnt).toLocaleString("en-US"),
                totalAmount: isNaN(rowData.totalAmount)?"0":"$"+Number(rowData.totalAmount).toLocaleString("en-US"),
                rejtUnkcnt: rowData.rejtUnkcnt,
            }));
            setRows1(_inputData);
        });
      }
    const loadDataGrid2 = async() => {
        await getAPI(API.CASH.VAULT_AMT,search).then((res) => {
            setRows2(res.data.result);
        });
    }
  
    //DataGrid에서 row 선택 시 
    function onSelectedRow(row){
    };
    const onSelectedRows = (e, row) => {
    };
      
    function onButtonClick(dvsn){
        if(dvsn==="조회"){
            loadDataGrid1(search);
        }
    };

    //폼 팝업
    const handleFormOpen = () => {
        setFormOpen(true);
    };
    const handleFormClose = () => {
        setFormOpen(false);
    };

    //상세팝업 클릭이벤트핸들러
    const handleRowSelect = (row) => {
        setSearch({
            ...search,
            ['storeCd']: row.rows.storeCd,
            ['machId']: row.rows.machId,
            ['startDate']: row.rows.saleDt.slice(0, 4)+"-"+row.rows.saleDt.slice(4, 6)+"-"+row.rows.saleDt.slice(6, 8)
        });
        handleFormOpen();   //상세팝업
    }
    return(
        <div className="main-container">
            <Box className="header">
                <Grid container>
                    <Grid item xs={18}>
                        {/* 상단메뉴명 */}
                        <UBreadCrumbs
                            title={"자금정보"}
                            subtitle={"시재현황"}
                        />
                    </Grid>
                </Grid>
            </Box>

            <div className="contents">
                {/* 조회조건 */}
                <TableContainer elevation={0} className="table-container">
                    <Table className="table" size="small">
                        <TableBody>
                        <TableRow className="table-row-header">
                            <TableCell className="table-cell-title">{fni18n("고객사")}</TableCell>
                            <TableCell className="table-cell">
                                <USelectBox
                                    name="bizTy"
                                    items={retailers}
                                    onItemChange={onSearchChange}
                                />
                            </TableCell>
                            <TableCell className="table-cell-title">{fni18n('지점')}</TableCell>
                            <TableCell className="table-cell">
                                {/* 점번선택 */}
                                <USelectBox
                                name="storeCd"
                                items={branchs} 
                                onItemChange = {onSearchChange}
                                defaultValue={search.storeCd}
                                />
                            </TableCell>
                            <TableCell className="table-cell-title">{fni18n('기기번호')}</TableCell>
                            <TableCell className="table-cell">
                                {/* 기번선택 */}
                                <USelectBox id="machId" name="machId" items={machineList} onItemChange={onSearchChange}/>
                            </TableCell>
                            <TableCell className="table-cell"></TableCell>
                            <TableCell className="table-cell"></TableCell>
                        </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className="search">
                    <UButton icon="Search" onButtonClick={onButtonClick}>조회</UButton>
                </div>
                <UTable columns={columns} rows={rows1} rowPerPage={11} />
        </div>
        {/* 팝업 */}
        <UPopupForm
            title={"상세"}
            open={formOpen}
            onClose={handleFormClose}
            content={<VaultPopUpPage data={search} />}
            type={"1"}
            maxWidth={"xxl"}
        />
    </div>
    );
}